module.exports = __webpack_public_path__ + "static/media/dna_step2.99497f45.svg";